import React from "react";
import Icon from "@mdi/react";
import { mdiWrench } from "@mdi/js";
import styles from "../styles.module.scss";

interface ActiveToolsIndicatorProps {
	activeTools: Map<string, string>;
}

export const ActiveToolsIndicator: React.FC<ActiveToolsIndicatorProps> = ({ activeTools }) => {
	if (activeTools.size === 0) return null;

	return (
		<>
			{Array.from(activeTools.entries()).map(([id, name]) => (
				<div
					key={id}
					className={styles.toolStatus}
				>
					<Icon
						path={mdiWrench}
						size={0.6}
						className={styles.toolStatusIcon}
					/>
					Executando: {name}
				</div>
			))}
		</>
	);
};
